<template>
  <b-btn v-bind="$attrs" v-on="$listeners" :disabled="loading || disabled">
    <template v-if="loading">
      <b-spinner small type="grow" />
      <template v-if="loadingText">{{ loadingText }}</template>
      <template v-else-if="!useLabel">{{ $t("common.loading") }}</template>
      <!-- @slot Button label -->
      <slot v-else />
    </template>
    <template v-else>
      <slot />
    </template>
  </b-btn>
</template>

<script>
/**
 * Button component that provides loading state indication.
 * Can be used during form submission.
 * In loading state shows spinner and disables button to prevent multiple form submissions.
 */
export default {
  props: {
    /**
     * Indicates if button is disabled
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Indicates button loading state
     */
    loading: {
      type: Boolean,
      default: false,
    },
    /**
     * Indicates if same label text should be shown in loading state.
     * If `false`, is shown `common.loading` text.
     * Is ignored if `loadingText = true`
     */
    useLabel: {
      type: Boolean,
      default: false,
    },
    /**
     * Text to show in loading state
     */
    loadingText: {
      type: String,
      default: null,
    },
  },
};
</script>